<button class="btn btn-primary" (click)="acceptCertificate($event)" type="button">Accept</button>
<button class="btn btn-default" (click)="rejectCertificate($event)" type="button">Reject</button>
